export default "__VITE_ASSET__EOqB0wZG__"